import { OutlinedTextFieldProps, TextField } from '@primitives';

export type DefaultTextFieldProps = Partial<OutlinedTextFieldProps>;

export const DefaultTextField = (props: DefaultTextFieldProps) => <TextField {...props} />;
